import { render, staticRenderFns } from "./StudentListView.vue?vue&type=template&id=df754ec0&scoped=true"
import script from "./StudentListView.vue?vue&type=script&lang=js"
export * from "./StudentListView.vue?vue&type=script&lang=js"
import style0 from "./StudentListView.vue?vue&type=style&index=0&id=df754ec0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df754ec0",
  null
  
)

export default component.exports